import { Button, Flex, Heading, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import CommonContainer from "../shared/CommonContainer";

export default function Banner() {
  const navigate = useNavigate();
  return (
    <Flex bgGradient={"linear(to-b,#0079BC,#74C7F5)"} py={20}>
      <CommonContainer>
        <Flex
          justifyContent={"space-between"}
          alignItems="center"
          color="white"
          gap={20}
        >
          <Stack gap={{ base: 4, lg: 8 }} pr={4} maxW={{ lg: "50%" }}>
            <Heading
              fontWeight={"semibold"}
              fontSize={{ base: "20px", md: "28px", xl: "43px" }}
            >
              Boost your earnings by driving traffic to Fiverr
            </Heading>
            <Text fontSize={{ base: "20px", xl: "29px" }}>
              Promote the leading marketplace for freelance services.
              <br /> Get paid to drive traffic. It’s that easy.
            </Text>
            <Button
              bg="brand.100"
              fontWeight={400}
              width={{ base: "220px", md: "260px" }}
              onClick={() => {
                navigate("/marketplace");
              }}
              py={{ base: 6, md: 8 }}
              fontSize={{ md: 20 }}
              _hover={{ color: "white", bg: "brand.100" }}
              borderRadius={16}
              border="3px solid"
              borderColor={"brand.100"}
            >
              Start Earning Now
            </Button>
          </Stack>
          <Image
            src="/images/affiliate/banner.png"
            display={{ base: "none", lg: "block" }}
          />
        </Flex>
      </CommonContainer>
    </Flex>
  );
}
